"use client";

import EngineDateTable from "@/components/vrat/EngineDateTable";
import type { CalendarEkadashiItem } from "@/lib/api/calendar";

export interface EkadashiYearData {
  year: number;
  ekadashis: CalendarEkadashiItem[];
}

export default function EkadashiDates({ years }: { years: EkadashiYearData[] }) {
  return (
    <EngineDateTable
      years={years.map(({ year, ekadashis }) => ({ year, entries: ekadashis }))}
      tabLabel="Ekadashi"
      itemHeader="Ekadashi"
      detailHeader="Hindu month"
      emptyMessage="Ekadashi dates are computed live from the Vedic engine. The schedule could not be loaded right now — please refresh in a moment to see every Ekadashi vrat date with its tithi."
      footer="All Ekadashi dates are computed from real planetary positions using the Swiss Ephemeris engine with Lahiri Ayanamsa — the tithi boundary, not a fixed calendar."
    />
  );
}
